import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";
import "react-toastify/dist/ReactToastify.css";

import { editField } from "../store/fileReducer";

import FeatureSelector from "./FeatureSelector";

export default ({ i }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [dataForApply, setDataForApply] = useState([]);
  const featuresFromRoot = useSelector(
    ({ file: { root } }) => root[i].features
  );

  const featureList = useSelector(({ templates }) => templates);

  const handleApply = () => {
    let featureNameList = "";
    dataForApply.forEach((item) => {
      featureNameList += Object.keys(item)[0] + ", ";
    });
    featureNameList = featureNameList.slice(0, -2);

    toast.success(
      <div>
        <b>{featureNameList}</b> added to feature list
      </div>
    );

    return dispatch(editField(`root[${i}].features`, dataForApply));
  };

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        color="primary"
        style={{
          color: !featuresFromRoot.length ? "red" : "green",
          borderColor: !featuresFromRoot.length ? "red" : "green",
        }}
        onClick={() => setIsOpen(true)}
      >
        Edit Features
      </Button>
      <Dialog
        fullWidth
        maxWidth="lg"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Features</DialogTitle>
        <DialogContent style={{ overflowX: "hidden" }}>
          <FeatureSelector
            featureList={featureList}
            featuresFromRoot={[...featuresFromRoot]}
            setDataForApply={setDataForApply}
          />
          <DialogActions>
            <Button
              style={{ marginRight: 20 }}
              onClick={handleApply}
              color="secondary"
            >
              Apply
            </Button>
            <Button onClick={() => setIsOpen(false)} color="secondary">
              Close
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};
